import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackLogisticsList from '../entities/back-logistics-list'
import IntoLogisticsCheckResult from '../entities/Into-logistics-checkresult'
import appconst from '@/lib/appconst';


interface BackLogisticsState extends ListState<BackLogisticsList> {
    LogisticsInfo: BackLogisticsList,
}

class BackLogisticsMutations extends ListMutations<BackLogisticsList>{

}
class BackLogistics extends ListModule<BackLogisticsState, any, BackLogisticsList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackLogisticsList>(),
        loading: false,
        logisticsInfo: BackLogisticsList,


    }
    actions = {
        async getAll(context: ActionContext<BackLogisticsState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Logistics/GetLogisticsList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackLogisticsList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getIntoLogisticsCheckResult(context: ActionContext<BackLogisticsState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Logistics/IntoLogisticsCheck', { params: payload.data });
            let page = reponse.data.result as IntoLogisticsCheckResult;
            return page;
        },
        async getNeedTakePictureList(context: ActionContext<BackLogisticsState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Logistics/GetNeedTakePictureList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as Array<BackLogisticsList>;
            return page;
        },
        async updateLogistics(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Logistics/Edit', payload.data);
        },
        async delete(state: any, payload: any) {
            let rep = await Ajax.delete('/api/services/app/Logistics/Delete?id=' + payload.data.id);
        },
        async isNeedTakePicture(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Logistics/IsNeedTakePicture?id=' + payload.data.id + '&isNeed=' + payload.data.isNeed);
        },
        async setTakePicture(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Logistics/SetTakePicture', payload.data);
        },
        async uploadLogisticsImg(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Logistics/UploadLogisticsImg', payload.data);
            return rep.data.result;
        },
        async SetTakePictureByPhone(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/Logistics/SetTakePictureByPhone', payload.data);
            return rep.data.result;
        },
        async uploadintoPicImg(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackOrder/UploadIntoPicBase64Img', payload.data);
            return rep.data.result;
        }
    };
    mutations = {
        setCurrentPage(state: BackLogisticsState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackLogisticsState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getImgUrl(state: BackLogisticsState, data: any) {
            if (data.imageGuid && data.imageGuid.length > 1) {
                data.url=appconst.remoteServiceBaseUrl + "api/File/GetLogisticsImage?guid=" + data.imageGuid;
            } else {
                data.url = null;
            }
        },
        getGoodsImgUrl(state: BackLogisticsState, datas: any) {
            if (datas.goodsImageGuid && datas.goodsImageGuid.length > 1) {
                datas.urls = appconst.remoteServiceBaseUrl + "api/File/GetLogisticsImage?guid=" + datas.goodsImageGuid;
            } else {
                datas.urls = null;
            }
        }
    }
}

const backLogistics = new BackLogistics();
export default backLogistics;